import { ThemeUIStyleObject } from "theme-ui";

export const linkCTAStyle: ThemeUIStyleObject = {
  position: "absolute",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const headingStylesGreen: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 9,
  pt: [6, 9, 11],
};

export const headingStylesCollection: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 10,
  pt: [6, 9, 11],
};
export const headingStylesWhiteCollection: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "h1"],
  mb: 10,
  color: "white",
  textAlign: "center",
  pt: [6, 9, 11],
};
export const textStylesWhiteCollection: ThemeUIStyleObject = {
  mb: 10,
  fontSize: ["paragraphMedium", "paragraphMedium", "paragraphLarge"],
  color: "white",
  textAlign: "center",
  // marginBottom: 15,
};
export const textStylesCollection: ThemeUIStyleObject = {
  mb: 10,
  fontSize: ["paragraphMedium", "paragraphMedium", "paragraph"],
  color: "darkGreen",
  textAlign: "center",
  // marginBottom: 15,
};
export const textStylesMatch: ThemeUIStyleObject = {
  fontSize: ["paragraphMedium", "paragraphMedium", "paragraph"],
  color: "darkGreen",
  textAlign: "start",
  marginBottom: 0,
};

export const headingStylesRed: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "center",
  pt: [6, 9, 11],
};

export const headingStylesRedLeft: ThemeUIStyleObject = {
  fontSize: ["h3", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "left",
  marginBottom: 9,
  pt: [6, 9, 11],
};

export const mainContainerStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
  bg: "white",
  px: [3, 6],
  pt: [3, 6],
  pb: [3, 6],
};
